export default __webpack_public_path__ + "static/media/parenting_app_logo.15a43ff2.png";